import { render, staticRenderFns } from "./base-heading.vue?vue&type=template&id=4be08d63&scoped=true"
import script from "./base-heading.vue?vue&type=script&setup=true&lang=js"
export * from "./base-heading.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-heading.vue?vue&type=style&index=0&id=4be08d63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be08d63",
  null
  
)

export default component.exports